import '../../App.css';
import { FaExternalLinkAlt } from "react-icons/fa";

function AboutMe() {
  return (
    <div id="AboutMe" className='project-animate'>
      <div className='port-img-pos'>
          <img src="./pictures/profolio.jpg" className='port-img' alt="portfolio"/>
      </div>
      <div>
          <h1 className="name">
              Hi, I'm Kevin Nguyen! <br/>
              Software Engineering at Adelaide University
          </h1>
          <div className="about">
              <div className='paragraph'> 
                  I am a Software Engineering student at the University of Adelaide with a strong interest in building reliable, 
                  user-focused software. I am actively seeking an internship where I can further develop my technical skills, 
                  collaborate with industry professionals, and contribute to real-world projects.
                  <br/>
                  <div className='hire-wrapper'>
                    <a href='/resume.pdf' download={'resume.pdf'} className='about-button'> Hire me <FaExternalLinkAlt/></a>
                    <span className='hire-tooltip'>
                      Download resume (PDF)
                    </span>
                  </div>
              </div>
          </div>
      </div>
    </div>
  );
}

export default AboutMe;